<script setup>
import { socialShareImage, usePageHead } from '@composables/use-page-head'
import { computed, onMounted, ref, watch } from 'vue'
import { usePlaybackStore } from '@stores/playback'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

const playbackStore = usePlaybackStore()

const mixes = ref([])

const recentlyPlayedMixes = computed(() => {
    const history = playbackStore && playbackStore.history

    return (
        history &&
        history.reduce((unique, id) => (unique.includes(id) ? unique : [...unique, id]), [])
    )
})

function getMixes() {
    const ids = recentlyPlayedMixes.value

    if (!ids || !ids.length) return

    Promise.all(ids.map(id => DataLayer.mixes.getById(id))).then(responses => {
        mixes.value = responses.map(response => response.body)
    })
}

watch(recentlyPlayedMixes, getMixes)

onMounted(getMixes)

usePageHead({
    title: 'Recently Played',
    description: 'Recently played DJ mixes on FRISKY.',
    image: socialShareImage(),
})
</script>

<template>
    <BaseSection
        v-if="mixes && mixes.length"
        padded
    >
        <MixGridBlock :mixes="mixes" />
    </BaseSection>
</template>
